/******************************************** STYLING *********************************************/
const s = require('./auth-panel-root.scss');

/************************************** THIRD-PARTY IMPORTS ***************************************/
import React from 'react';
import cn from 'classnames';

/**************************************** TYPE DEFINITIONS ****************************************/
interface AuthPanelRootViewProps {
    children: JSX.Element;
}

/********************************************* EXPORT *********************************************/
/**
 * Wrapper around auth-panel content card (for styling)
 *
 * Displays e.g. background, border, etc
 * Passes children thru: i.e. children get wrapped by the card styling component
 *
 *  UI Outline:              Once populated with children (example):
 *     __________               __________
 *    /          \             /          \
 *    |          |             |  Log in  |
 *    |          |             |  ______  |
 *    |          |             |  ______  |
 *    |          |             |          |
 *    |          |             | <submit> |
 *    \__________/             \__________/
 */
export class AuthPanelRootView extends React.Component<AuthPanelRootViewProps> {
    render() {
        return <div className={cn(s[`auth-panel-box-wrapper`])}>{this.props.children}</div>;
    }
}
